<!-- Table for Locations -->
<div class="form-group row">
    <label class="col-md-2 col-form-label"
           [ngClass]="{'required-text' : required}">Locations</label>
    <div class="col-md-10">
        <table class="table">
            <thead>
                <tr>
                    <th class="icon-cell col-size-fit">
                        <a (click)="addLocation(job)"
                           class="add-item-link"
                           *ngIf="!readonly">
                            <i class="fa fa-plus-circle" title="Add Location"></i>
                        </a>
                    </th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let jobLocation of job.JobLocation">
                    <td class="text-center align-middle">
                        <a *ngIf="!readonly" (click)="removeLocation(jobLocation)">
                            <i class="fa fa-fw fa-remove remove-item"
                               title="Delete Location"></i>
                        </a>
                    </td>
                    <td>
                        <location-chooser [(location)]="jobLocation.LocationPosition"
                                          [required]="required"
                                          [readonly]="readonly || job.IsLocked"></location-chooser>
                    </td>                                   
                </tr>
            </tbody>
        </table>
    </div>
</div>
